module.exports = __webpack_public_path__ + "img/cup_icon.ebac0c11.svg";